/**
 * How many times a proposal has been revised.
 *
 * `revisionNumber` from the API is a VERSION number: a new proposal is version 1,
 * and finalising the first revision makes it version 2. Printing that number
 * straight out labelled the first revision "Revision 2", so every revision read
 * one higher than the crew counted — and because the version only moves when a
 * manager approves, it looked as though approval were adding revisions of its own.
 *
 * The label counts revisions instead: version 2 is "Revision 1". The original
 * returns 0 and carries no label at all.
 *
 * Mirrored in paver-backend/src/lib/revision-label.ts — the proposal is rendered on
 * both sides (the on-screen and signing views here, the PDF there) and the two must
 * agree.
 */
export function revisionCount(versionNumber?: number | null): number {
  return Math.max(0, (versionNumber || 1) - 1)
}
